// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"b876bfcc","213":"d51c27ae","453":"e8017814","455":"d76ed980","524":"e127f406","756":"3c0b2d06"}[chunkId] + ".chunk.js";
};